import SiteAssignmentsDto from "../components/Common/dtos/SiteAssignmentsDto";
import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useUser } from "../components/UserAccess/useUser";

const useGetDriverSiteAssignment = (driverId?: string, options?: QueryOptions<SiteAssignmentsDto>) => {
  const user = useUser();

  return useUserQuery<SiteAssignmentsDto>(
    { path: `/api/businesses/${user.selectedBusiness?.id!}/drivers/${driverId}/siteAssignment` },
    options);
}

export default useGetDriverSiteAssignment;
